export default "__VITE_PUBLIC_ASSET__0528c522__"